import React from 'react';
import './styles.scss'

import {Link} from '../../../../../../router';
import ActionDropdown from "../../../../../helpers/Table/components/TableBase/components/ActionsDropdown";
import MenuVertIcon from "../../../../../icons/MenuVert";
import MerchantDropdown from "../../../../../layouts/components/helpers/MerchantDropdown";
import Ripple from "../../../../../dumb/Ripple";

export default ({classNameEffect, title, stats, info, linkProps = {}, imgProps = {}, actionsProps}) => (
  <div className={`terminals-card` + (classNameEffect ? ` terminals-card--${classNameEffect}` : '')}>
    <div className="terminals-card__data">
      <div className="terminals-card__title">
        {title}
      </div>
      {stats && (
        <div className="terminals-card__stats">
          {stats.map((el) => (
            <div className="layoutRow aiC">
              {el.reduce((prev, curr) => [prev, ': ', curr])}
            </div>
          ))}
        </div>
      )}
      {info && (
        <div className="terminals-card__info">
          {info}
        </div>
      )}
      <Link className="terminals-card__link" href={linkProps.href}>
        <span>
          {linkProps.text}
        </span>
        <div className="terminals-card__link-icon">
          <svg className="dB" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.75L1.2228 10L6 5L1.2228 9.53674e-07L0 1.25L3.6 5L0 8.75Z" />
          </svg>
        </div>
      </Link>
    </div>
    <div className="terminals-card__img">
      <img {...imgProps} />
    </div>
    {actionsProps && (
      <div className="terminals-card__actions">
        <MerchantDropdown
          {...actionsProps}
          className="terminals-card__actions-dropdown"
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          itemsList={
            actionsProps.itemsList.map((el, i) => (
              <Ripple key={i} className="terminals-card__actions-item" onClick={el.onClick}>
                {el.name}
              </Ripple>
            ))
          }
          hideCaret
        >
          <div className="table-actions__icon">
            <MenuVertIcon width={4} />
          </div>
        </MerchantDropdown>
      </div>
    )}
  </div>
)
